(function () {
  if (window.labooCartRequest) return;

  var tierCodes = ["EXTRA5", "EXTRA10", "EXTRA15"];
  var discountSync = Promise.resolve();

  function isCartMutation(url) {
    return /\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(String(url));
  }

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + path;
  }

  function desiredTierCode(itemCount) { if (window.LabooTrade) return ""; /* 6 Oct 2026: trade accounts get their trade discount, not multi-buy codes */
    if (itemCount >= 4) return "EXTRA15";
    if (itemCount >= 3) return "EXTRA10";
    if (itemCount >= 2) return "EXTRA5";
    return "";
  }

  function normalizeDiscountCodes(discounts) {
    return Array.isArray(discounts) ? discounts.map(function (discount) {
      if (typeof discount === "string") return { code: discount };
      return { code: String(discount && discount.code || "") };
    }).filter(function (discount) {
      return discount.code;
    }) : [];
  }

  function displayedItemCount() {
    var countElement = document.querySelector("[data-header-cart-count]");
    var count = countElement ? parseInt(countElement.textContent, 10) : NaN;
    return Number.isFinite(count) ? count : null;
  }

  function addedQuantity(options) {
    var body = options && options.body;

    if (typeof body !== "string") return null;

    try {
      var jsonBody = JSON.parse(body);
      if (Array.isArray(jsonBody.items)) {
        return jsonBody.items.reduce(function (total, item) {
          return total + Math.max(0, parseInt(item && item.quantity, 10) || 0);
        }, 0);
      }
      if (jsonBody.quantity) return Math.max(1, parseInt(jsonBody.quantity, 10) || 1);
    } catch (error) {
      // Form-encoded product requests are handled below.
    }

    if (typeof URLSearchParams !== "function") return null;

    var params = new URLSearchParams(body);
    var itemQuantity = 0;

    params.forEach(function (value, key) {
      if (/^items\[\d+\]\[quantity\]$/.test(key)) {
        itemQuantity += Math.max(0, parseInt(value, 10) || 0);
      }
    });

    if (itemQuantity > 0) return itemQuantity;

    var quantity = parseInt(params.get("quantity") || "1", 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function predictedCartAfterAdd(options) {
    var state = window.LabooCartState || {};
    var currentCount = displayedItemCount();
    var quantity = addedQuantity(options);

    if (currentCount === null) {
      currentCount = Number.isFinite(Number(state.itemCount)) ? Number(state.itemCount) : null;
    }

    if (currentCount === null || quantity === null) return null;

    return {
      item_count: currentCount + quantity,
      discount_codes: normalizeDiscountCodes(state.discountCodes)
    };
  }

  function rememberCart(cart) {
    if (!cart || typeof cart.item_count !== "number") return cart;

    window.LabooCartState = {
      itemCount: cart.item_count,
      discountCodes: normalizeDiscountCodes(cart.discount_codes)
    };

    return cart;
  }

  function fetchJson(url, options) {
    return window.labooNativeFetch(url, options).then(function (response) {
      return response.json().catch(function () {
        return {};
      });
    });
  }

  function withBundledCartSection(url, options) {
    var bundledOptions = Object.assign({}, options || {});
    bundledOptions.headers = Object.assign({}, bundledOptions.headers || {});

    if (!isCartMutation(url)) return bundledOptions;

    var contentType = String(bundledOptions.headers["Content-Type"] || bundledOptions.headers["content-type"] || "");

    if (contentType.indexOf("application/json") !== -1) {
      var jsonBody = {};

      try {
        jsonBody = bundledOptions.body ? JSON.parse(bundledOptions.body) : {};
      } catch (error) {
        jsonBody = {};
      }

      jsonBody.sections = ["helper-cart"];
      jsonBody.sections_url = window.location.pathname;
      bundledOptions.body = JSON.stringify(jsonBody);
    } else if (typeof bundledOptions.body === "string" && typeof URLSearchParams === "function") {
      var params = new URLSearchParams(bundledOptions.body);
      params.set("sections", "helper-cart");
      params.set("sections_url", window.location.pathname);
      bundledOptions.body = params.toString();
    }

    return bundledOptions;
  }

  function syncTierDiscount(cartResponse, url, options) {
    if (typeof window.labooNativeFetch !== "function") return Promise.resolve();

    var cartRequest;

    if (cartResponse && typeof cartResponse.item_count === "number") {
      cartRequest = Promise.resolve(cartResponse);
    } else if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url))) {
      var predictedCart = predictedCartAfterAdd(options);
      cartRequest = predictedCart ? Promise.resolve(predictedCart) : null;
    }

    if (!cartRequest) {
      cartRequest = fetchJson(cartUrl("cart.js"), {
        headers: { "Accept": "application/json" }
      });
    }

    return cartRequest.then(function (cart) {
      var desiredCode = desiredTierCode(Number(cart.item_count) || 0);
      var existingCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      var retainedCodes = existingCodes.map(function (discount) {
        return String(discount.code || "");
      }).filter(function (code) {
        return code && tierCodes.indexOf(code.toUpperCase()) === -1;
      });
      var activeTier = existingCodes.map(function (discount) {
        return String(discount.code || "").toUpperCase();
      }).find(function (code) {
        return tierCodes.indexOf(code) !== -1;
      }) || "";

      if (activeTier === desiredCode) return rememberCart(cart);
      if (desiredCode) retainedCodes.push(desiredCode);

      return fetchJson(cartUrl("cart/update.js"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          discount: retainedCodes.join(","),
          sections: ["helper-cart"],
          sections_url: window.location.pathname
        })
      }).then(rememberCart);
    });
  }

  function nativeRequest(url, options) {
    var method = String((options && options.method) || "GET").toUpperCase();
    var requestFetch = method !== "GET" && /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url)) && typeof window.fetch === "function"
      ? window.fetch.bind(window)
      : window.labooNativeFetch;
    return requestFetch(url, options).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!data || typeof data !== "object") data = {};
        if (!data.status) data.status = response.status;
        return data;
      });
    });
  }

  function xhrRequest(url, options) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open(options.method || "GET", url, true);
      request.timeout = 15000;

      Object.keys(options.headers || {}).forEach(function (name) {
        request.setRequestHeader(name, options.headers[name]);
      });

      request.addEventListener("load", function () {
        var response = {};

        try {
          response = request.responseText ? JSON.parse(request.responseText) : {};
        } catch (error) {
          response = {};
        }

        if (!response || typeof response !== "object") response = {};
        if (!response.status) response.status = request.status;
        resolve(response);
      });

      request.addEventListener("error", function () {
        reject(new Error("Cart request failed"));
      });

      request.addEventListener("timeout", function () {
        reject(new Error("Cart request timed out"));
      });

      request.send(options.body || null);
    });
  }

  window.labooCartRequest = function (url, options) {
    options = options || {};
    var requestOptions = withBundledCartSection(url, options);
    var request = typeof window.labooNativeFetch === "function"
      ? nativeRequest(url, requestOptions)
      : xhrRequest(url, requestOptions);

    if (!isCartMutation(url)) return request;

    return request.then(function (response) {
      if (response && response.status >= 400) return response;

      discountSync = discountSync.catch(function () {
        return {};
      }).then(function () {
        return syncTierDiscount(response, url, options);
      });

      return discountSync.then(function (updatedCart) {
        return updatedCart && typeof updatedCart === "object" ? updatedCart : response;
      }).catch(function () {
        return response;
      });
    });
  };

  window.labooCartSectionText = function (response) {
    var sections = response && response.sections;
    var bundledSection = sections && sections["helper-cart"];

    if (typeof bundledSection === "string" && bundledSection) {
      return Promise.resolve(bundledSection);
    }

    var request = typeof window.labooNativeFetch === "function" ? window.labooNativeFetch : window.fetch;
    return request("?section_id=helper-cart").then(function (sectionResponse) {
      return sectionResponse.text();
    });
  };
})();
